export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Sent successfully",
      error: "Submission error",
      notConfigured: "Not configured",
      pending: "Pending submission",
    },
    errorNoInfo: "Error (no details)",
  },
  msgPolice: {
    title: "Information",
    pendingSyncText:
      "The check-in details are pending synchronization; they will be sent to the local authorities on the same day the guest arrives at the accommodation.",
    entryDateLabel: "Arrival date:",
    syncedText:
      "The details for guest {name} have been synchronized with the local authorities successfully.",
    syncDateLabel: "Synchronization date:",
    errorText:
      "Due to external reasons, synchronization with the local authorities could not be completed.",
    close: "Close",
  },
};
